import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import styles from "./style.module.scss";
import { Images } from "assets";
import useWindowSize from "shared/customHooks/windowSize";
import React, { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { routeConstant } from "shared/routes/routesConstant";

function AdminRolesDashboard() {
  const navigate = useNavigate();

  const screenWidth = useWindowSize();
  const [loader, setLoader] = useState<boolean>(false);

  useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  }, []);

  const adminRoles = [
    {
      label: "Product Manager",
      role: "product-manager",
    },
    {
      label: "HOD Content",
      role: "hod-content",
    },
    {
      label: "Admin",
      role: "admin",
    },
    {
      label: "Accountant",
      role: "accountant",
    },
  ];
  return (
    <div className={styles.mainContainer}>
      <div className={styles.upperContainer}>
        <div className={styles.headingContainer}>
          <label className={styles.heading}>Main Admin Roles</label>
          <label className={styles.subHeading}>
            You can open their Dashboard
          </label>
        </div>

        {loader ? (
          <div className={styles.statsContainer}>
            <div className={styles.statsGridContainer}>
              <label className={styles.statsCounter}>
                <Skeleton variant="rounded" width={45} height={30} />
              </label>
              <label className={styles.statsLabel}>
                <Skeleton variant="rounded" width={75} height={20} />
              </label>
            </div>
            <div className={styles.separator} />
            <div className={styles.statsGridContainer}>
              <label className={styles.statsCounter}>
                <Skeleton variant="rounded" width={45} height={30} />
              </label>
              <label className={styles.statsLabel}>
                <Skeleton variant="rounded" width={75} height={20} />
              </label>
            </div>
          </div>
        ) : (
          <div className={styles.statsContainer}>
            <div className={styles.statsGridContainer}>
              <label className={styles.statsCounter}>04</label>
              <label className={styles.statsLabel}>Admin Roles</label>
            </div>
            <div className={styles.separator} />
            <div className={styles.statsGridContainer}>
              <label className={styles.statsCounter}>54</label>
              <label className={styles.statsLabel}>Pending Task</label>
            </div>
          </div>
        )}
      </div>

      <TableContainer
        component={Paper}
        className={styles.tableContainer}
        sx={screenWidth > 990 ? { width: `${screenWidth - 300}px` } : {}}
        id="table-view-dashboard"
      >
        <Table>
          <TableHead className={styles.tableHead}>
            <TableRow>
              <TableCell>Admin Roles</TableCell>
              <TableCell>Admin Name</TableCell>
              <TableCell>Phone No</TableCell>
              <TableCell>Pending Task</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={styles.tableBody}>
            {loader ? (
              <Loader />
            ) : (
              adminRoles?.map((item: any, index: any) => {
                return (
                  <TableRow key={index}>
                    <TableCell>{item?.label}</TableCell>
                    <TableCell>
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <img
                          src={Images.UserPlaceholderImage}
                          alt="admin"
                          className={styles.adminProfilePicture}
                        />

                        <label>Admin Name</label>
                      </div>
                    </TableCell>
                    <TableCell>0300-000000</TableCell>
                    <TableCell>
                      <label className={styles.pendingTaskLabel}>25</label>
                    </TableCell>
                    <TableCell className={styles.actionCell}>
                      <label
                        onClick={() =>
                          navigate(
                            routeConstant.dashboardView.path.replace(
                              ":role",
                              item?.role
                            )
                          )
                        }
                      >
                        Open Dashboard
                      </label>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default AdminRolesDashboard;

const Loader = () => {
  return (
    <React.Fragment>
      {Array.from({ length: 4 }).map((item, index) => {
        return (
          <TableRow key={index} id={styles.loaderRow}>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={25} />
            </TableCell>
            <TableCell>
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="rounded" width={100} height={25} />
              </div>
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={120} height={25} />
            </TableCell>
            <TableCell>
              <Skeleton variant="rounded" width={30} height={25} />
            </TableCell>
            <TableCell className={styles.actionCell}>
              <Skeleton variant="rounded" width={130} height={25} />
            </TableCell>
          </TableRow>
        );
      })}
    </React.Fragment>
  );
};
